<template>
    <div class="container">
        <h1 class="title">{{ title }}</h1>

        <div v-if="data != ''" v-for='item in list' class="verItem">
            <label> {{ item.label }} </label>
            <span style="margin-left: 20px;"> {{ data[item.name] }} </span>
        </div>
    </div>
</template>
  
<script>
import {
    getURLReportData,
} from "../../api/userMG";
export default {
    name: "App",
    data() {
        return {
            CID: "",
            UID: "",
            list: [
                {
                    label: '订单:',
                    name: 'UID',
                    value: ''
                },
                {
                    label: '车号:',
                    name: "carNo",
                    value: ''
                }, {
                    label: '产品:',
                    name: "Goods",
                    value: ''
                }, {
                    label: '皮重:',
                    name: "gross",
                    value: ''
                }, {
                    label: '毛重:',
                    name: "tare",
                    value: ''
                }, {
                    label: '净重:',
                    name: "net",
                    value: ''
                }, {
                    label: '入场:',
                    name: "time1",
                    value: ''
                }, {
                    label: '出厂:',
                    name: "time2",
                    value: ''
                }],
            data: [
                // {
                //     "UID": "A202211060005",
                //     "Goods": "货名4",
                //     "carNo": "粤B888ZX",
                //     "gross": "1600.000",
                //     "tare": "1400.000",
                //     "net": "200.000",
                //     "time1": "2022/11/6 16:08:56",
                //     "time2": "2022/11/6 16:09:09",
                //     "finish": "1"
                // }
            ],
            title: "",
        };
    },
    mounted() {
        document.title = title;
        if (this.$route.query.CID && this.$route.query.UID) {
            this.CID = this.$route.query.CID;
            this.UID = this.$route.query.UID;
            this.title = title;
            this.init();
        }
    },
    methods: {
        init() {
            let that = this;
            let params = {
                CID: this.CID,
                UID: this.UID,
            };
            // 校验手机号
            getURLReportData(params).then((res) => {
                if (res.data.code == 100) {
                    let data = res.data.data[0];
                    that.data = data;
                }
            });
        }
    },
};
</script>
  
<style scoped lang="less">
.title {
    text-align: center;
    padding: 20px 0;
}

.verItem {
    width: 80%;
    border-bottom: 1px solid gray;
    padding: 16px 10px;
    margin: 0 auto;

    label {
        font-size: 18px;
    }

    span {
        font-size: 18px;
    }
}

.container {
    width: 100%;
    position: absolute;
    z-index: -9999;
}
</style>
  


// WEBPACK FOOTER //
// src/views/outReport/verification10203.vue